// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
.container-smart-component {
  padding-block-end: 0;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}

.icon-main {
  width: var(--size-icon-main);
  height: var(--size-icon-main);
  flex-shrink: 0;
  background-color: #FF8800;
  color: white;
  font-size: 35px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .icon-main {
  font-size: 50px;
}
.supervision-view .title {
  font-size: 15px;
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

ion-button.dimmer-switch {
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  width: 50px;
  height: 50px;
  --background: #E9E9E9;
  --box-shadow: 0;
  --ripple-color: #FFA527;
  color: var(--ion-color-dark);
  --transition: transform .2s ease-out;
}
ion-button.dimmer-switch.turn-on {
  --background: #FF8800;
}
ion-button.dimmer-switch.turn-on ion-icon {
  color: rgba(255, 255, 255, 0.8);
}
ion-button.dimmer-switch ion-icon {
  font-size: 35px;
  color: var(--ion-color-medium-shade);
}
ion-button.dimmer-switch.ion-activated {
  transform: scale(1.2);
}

.toggle-button {
  color: var(--ion-color-medium-shade);
  display: block;
  font-size: 24px;
  cursor: pointer;
  margin-inline: auto;
  margin-block-start: 5px;
}

.icon-states {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: var(--ion-color-medium-shade);
  flex-basis: 100%;
  margin-block-end: 10px;
}
.icon-states ion-icon {
  font-size: 24px;
}
.icon-states.bigger-icon {
  margin-block: 10px;
  margin-inline: auto;
  gap: 30px;
}
.icon-states.bigger-icon ion-icon {
  font-size: 45px;
}
.icon-states.bigger-icon span {
  font-size: 12px;
}
.icon-states.bigger-icon span ion-icon {
  font-size: 28px;
}
.icon-states span {
  font-size: 10px;
  line-height: 1.4;
  display: flex;
  font-weight: 600;
  flex-direction: column;
  align-items: center;
}
.icon-states span ion-icon {
  font-size: 16px;
}

ion-icon.active {
  color: #FF8800;
}

.fault-state {
  color: #9e0505;
}

.current-value {
  text-align: center;
  font-weight: 700;
  line-height: 1;
  font-size: 26px;
}
.current-value span {
  font-size: 16px;
}

.temperature-color {
  color: var(--ion-color-medium-shade);
}

.visible-section {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.commands-states-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(var(--height-smart-component-compact) - var(--padding-component) - var(--size-icon-main));
}
.commands-states-section .expanded-section {
  margin-block-start: 30px;
}
.commands-states-section .expanded-section > * + * {
  margin-block-start: 30px;
}

.title-label {
  text-transform: uppercase;
  font-size: 14px;
  color: #8b8b8b;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
}

ion-toggle {
  margin: 0 10px;
  --track-background: #FFA527;
  --track-background-checked: #FF8800;
}

.container-automan-command {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-sensor/widget-sensor.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAtBA;EAGI,oBAAA;AAsBJ;;AAnBA;ECqBI,aAAA;EACA,mBAAA;EACA,SAAA;ADEJ;ACAI;EACI,2BAAA;EACA,iBAAA;ADER;ACCI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADCR;ACCQ;EACI,gBAAA;ADCZ;ACGI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADDR;;AAvCA;ECkDI,4BAAA;EACA,6BAAA;EACA,cAAA;EDlDA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4CJ;;AAzCA;EC6CI,eAAA;EACA,gBAAA;ADAJ;;AAzCI;EACI,eAAA;AA4CR;AAzCI;EACI,eAAA;AA2CR;;AAvCA;ECoBI,kFAAA;EACA,WAAA;ADuBJ;;AAxCA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;AA2CJ;AAzCI;EACI,qBAAA;AA2CR;AAzCQ;EACI,+BAAA;AA2CZ;AAvCI;EACI,eAAA;EACA,oCAAA;AAyCR;AAtCI;EACI,qBAAA;AAwCR;;AApCA;EACI,oCAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AAuCJ;;AApCA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;AAuCJ;AArCI;EACI,eAAA;AAuCR;AApCI;EACI,kBAAA;EACA,mBAAA;EACA,SAAA;AAsCR;AApCQ;EACI,eAAA;AAsCZ;AAnCQ;EACI,eAAA;AAqCZ;AAnCY;EACI,eAAA;AAqChB;AAhCI;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAkCR;AAhCQ;EACI,eAAA;AAkCZ;;AA5BI;EACI,cAAA;AA+BR;;AA3BA;EACI,cAAA;AA8BJ;;AA3BA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA8BJ;AA5BI;EACI,eAAA;AA8BR;;AA1BA;EACI,oCAAA;AA6BJ;;AA1BA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AA6BJ;;AA1BA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,0GAAA;AA6BJ;AA3BI;EACI,wBAAA;AA6BR;AA3BQ;EACI,wBAAA;AA6BZ;;AAxBA;EACI,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA2BJ;;AAxBA;EACI,cAAA;EACA,2BAAA;EACA,mCAAA;AA2BJ;;AAxBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AA2BJ","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n    @include external-apparance;\n\n    padding-block-end: 0;\n}\n\n.icon-and-text {\n    @include icon-and-text;\n}\n\n.icon-main {\n    @include icon-main;\n    background-color: #FF8800;\n    color: white;\n    font-size: 35px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.title {\n    @include title-main;\n}\n\n.supervision-view {\n    .icon-main {\n        font-size: 50px;\n    }\n\n    .title {\n        font-size: 15px;\n    }\n}\n\n.container-spinner {\n    @include container-spinenr;\n}\n\nion-button.dimmer-switch {\n    --border-radius: 50%;\n    --padding-start: 0;\n    --padding-end: 0;\n    width: 50px;\n    height: 50px;\n    --background: #E9E9E9;\n    --box-shadow: 0;\n    --ripple-color: #FFA527;\n    color: var(--ion-color-dark);\n    --transition: transform .2s ease-out;\n\n    &.turn-on {\n        --background: #FF8800;\n\n        ion-icon {\n            color: rgba($color: #FFF, $alpha: 0.8);\n        }\n    }\n\n    ion-icon {\n        font-size: 35px;\n        color: var(--ion-color-medium-shade);\n    }\n\n    &.ion-activated {\n        transform: scale(1.2);\n    }\n}\n\n.toggle-button {\n    color: var(--ion-color-medium-shade);\n    display: block;\n    font-size: 24px;\n    cursor: pointer;\n    margin-inline: auto;\n    margin-block-start: 5px;\n}\n\n.icon-states {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    color: var(--ion-color-medium-shade);\n    flex-basis: 100%;\n    margin-block-end: 10px;\n\n    ion-icon {\n        font-size: 24px;\n    }\n\n    &.bigger-icon {\n        margin-block: 10px;\n        margin-inline: auto;\n        gap: 30px;\n\n        ion-icon {\n            font-size: 45px;\n        }\n\n        span {\n            font-size: 12px;\n\n            ion-icon {\n                font-size: 28px;\n            }\n        }\n    }\n\n    span {\n        font-size: 10px;\n        line-height: 1.4;\n        display: flex;\n        font-weight: 600;\n        flex-direction: column;\n        align-items: center;\n\n        ion-icon {\n            font-size: 16px;\n        }\n    }\n}\n\nion-icon {\n    &.active {\n        color: #FF8800;\n    }\n}\n\n.fault-state {\n    color: #9e0505;\n}\n\n.current-value {\n    text-align: center;\n    font-weight: 700;\n    line-height: 1;\n    font-size: 26px;\n\n    span {\n        font-size: 16px;\n    }\n}\n\n.temperature-color {\n    color: var(--ion-color-medium-shade);\n}\n\n.visible-section {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n.commands-states-section {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: calc(var(--height-smart-component-compact) - var(--padding-component) - var(--size-icon-main));\n\n    .expanded-section {\n        margin-block-start: 30px;\n\n        &>*+* {\n            margin-block-start: 30px;\n        }\n    }\n}\n\n.title-label {\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #8b8b8b;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 10px;\n}\n\nion-toggle {\n    margin: 0 10px;\n    --track-background: #FFA527;\n    --track-background-checked: #FF8800;\n}\n\n.container-automan-command {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
